import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
  Typography,
} from '@mui/material';
import { DialogProps } from './types';
import useRestrictionSelectorStyles from './styles';
import clsx from 'clsx';
import {
  DocumentationButton,
  DocumentPath,
} from 'components/layouts/PageHeader/DocumentationButton';
import { withLoadingContext } from 'contexts/HOCs/withLoadingContext';
import LoadingBar from 'components/LoadingBar';

const Dialog: React.FunctionComponent<DialogProps> = (props) => {
  const {
    open = true,
    title,
    buttons,
    children,
    dialogProps,
    containerClassName,
    contentClassName,
    document,
    subtitle,
    headerButtons,
  } = props;
  const classes = useRestrictionSelectorStyles(props);

  return (
    <MuiDialog open={open} {...dialogProps}>
      <LoadingBar absolute />
      <div className={clsx(classes.container, containerClassName)}>
        <Box display='flex'>
          <DialogTitle component='h3' variant='h3' className={classes.title}>
            {title}
          </DialogTitle>

          {headerButtons && <div className={classes.headerButtons}>{headerButtons}</div>}
        </Box>

        {document && (
          <div className={classes.documentButton}>
            <DocumentationButton document={DocumentPath[document]} />
          </div>
        )}
        {subtitle && (
          <Typography className={classes.subtitle} variant='subtitle2'>
            {subtitle}
          </Typography>
        )}
        <DialogContent className={contentClassName}>{children}</DialogContent>
        <DialogActions>{buttons}</DialogActions>
      </div>
    </MuiDialog>
  );
};

export default withLoadingContext(Dialog);
